// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-icon {
  padding-right: 1%;
}

:host {
  display: flex;
}`, "",{"version":3,"sources":["webpack://./src/app/components/icon/icon.component.scss"],"names":[],"mappings":"AAAA;EAEI,iBAAA;AAAJ;;AAGA;EAEI,aAAA;AADJ","sourcesContent":["ion-icon \r\n{\r\n    padding-right: 1%;\r\n}\r\n\r\n:host\r\n{\r\n    display:flex;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
